export default __webpack_public_path__ + "static-bigflip/media/offline-umkm.e24955b9.webp";